export const EXCEPTION_MESSAGES = {
    NOT_FOUND_DB: "User not in DB",
    CONFLICT: "Duplicate user",
    USER_NOT_FOUND: "User not found",
    UNAUTHORIZED: "Invalid password",
    INVALID_REFRESH_TOKEN: "Invalid refresh token",
}

export const LOCALSTORAGE_ITEMS = {
    ACCESS_TOKEN: "access_token",
    ALL_CAMPAIGNS: "all_campaigns",
    ALL_TAGS_AND_PRODUCTS: "all_tags_and_products",
    ALL_ORDER_PRODUCTS: "all_order_products",
    APP_VERSION: "app_version",
    CALL_TS: "call_ts",
    CAMPAIGNS_ARE_VISIBLE: "campaigns_are_visible",
    CONTINUE_IN_BROWSER: "continue_in_browser",
    CONTINUE_AS_GUEST: "continue_as_guest",
    CURRENT_CART: "current_cart",
    DEMO_ACCOUNT_MSG_WAS_SHOWN: "demo_account_msg_was_shown",
    HAS_BACK_BUTTON: "back_button_enabled",
    HAS_RESERVATIONS: "has_reservations",
    LOCALE: "locale",
    LOYALTY_PRODUCTS_POINTS: "loyalty_products_points",
    ORDER_ID: "order_id",
    GROUP_ORDER_ID: "group_order_id",
    ORDER_PLACE: "order_place",
    ORDERS_HISTORY: "orders_history",
    PAYMENT_METHOD: "payment_method",
    PLAY_SOUND: "play_sound_allowed",
    PRODUCT_ID: "product_id",
    PRODUCT_DETAILS: "product_details",
    REFRESH_TS: "refresh_ts",
    RESERVATION_INFO: "reservation_info",
    SCROLL_POSITION: "scroll_position",
    SHOP_DETAILS: "shop_details",
    SHOP_NAME: "shop_name",
    SUBORDERS: "suborders",
    CARD_DETAILS: "card_details",
    USER_ACCEPTED_COOKIES: "user_accepted_cookies",
    USER_EMAIL: "user_email",
    USER_EMAIL_ANONYMOUS: "user_email_anonymous",
    USER_INFO_ANONYMOUS: "user_info_anonymous",
    USER_TABLE: "user_table",
    USER_TYPE: "user_type",
    USER_INFO: "user_info",
    PHONE_TOKEN: "phone_token",
    PREVIOUS_TRANSACTION_ID: "previous_transaction_id",
    TRANSLATION:"translations",
    TRANSLATION_TS:"translationsTs"
}


export const  HEADER_SIZE = {
    BIG_NO_GRADIENT: "big no-gradient",
    BIG: "big",
    MEDIUM: "medium",
    SMALL: "small"
}

export const ORDER_PLACE = {
    TABLE: "TABLE",
    BAR: "BAR",
    TAKEAWAY:"TAKEAWAY",
    DELIVERY:"DELIVERY",
    NOT_FOUND: "NOT_FOUND"
}

export const procStatuses = {
    OPEN: "OPEN",
    CONFIRMED: "CONFIRMED",
    READY:"READY",
    CHECKOUT: "CHECKOUT",
    DELIVERED: "DELIVERED",
    DECLINED: "DECLINED",
    SENT: "SENT"
}

export const  ELEMENT_PICKER_TYPES = {
    HOUR_PICKER: "hour_picker",
    NUMBER_OF_PEOPLE_PICKER: "number_of_people_picker"
}

export const FIREBASE_SCREEN_NAMES = {
    RESTAURANT:"WEB_Restaurant",
    ALL_RESERVATIONS: "WEB_ReservationsList",
    RESERVATION_DETAILS: "WEB_ReservationDetails",
    CREATE_RESERVATION:  "WEB_CreateReservation",
    ALL_PRODUCTS: "WEB_Menu",
    PRODUCT_DETAILS: "WEB_ProductDetails",
    ORDER_REVIEW:    "WEB_SelectTable",
    ORDER_SUMMARY:   "WEB_OrderMore",
    GROUP_ORDER_SUMMARY:   "WEB_GroupOrderSummary",
    PAYMENT:   "WEB_PaymentOptions",
    THANK_YOU: "WEB_OrderDetails",
    TAKEAWAY: "WEB_TakeAway",
    PROFILE_UPDATE: "WEB_ProfileUpdate",
    PROFILE_CHANGE_PASSWORD: "WEB_ProfileChangePassword",
    PROFILE_DELETE: "WEB_ProfileDelete",
    SCHEDULES: "WEB_Schedules",
    LOGIN_OR_CONTINUE_AS_GUEST: "WEB_LoginOrContinueAsGuest"
}

export const DEFAULT_TIP_VALUES = {
    GOOD: "5",
    GREAT: "10",
    EXCELLENT: "15"
}

export const USER_TYPES = {
    ANONYMOUS: "ANONYMOUS",
    VERIFIED: "VERIFIED"
}

export const PRODUCT_TYPE = {
    DINE_IN: "DINE_IN",
    TAKEAWAY: "TAKEAWAY"
}

export const PAYMENT_TYPES = {
    CASH: "CASH",
    CARD: "CARD",
    ONLINE: "ONLINE",
    WAITER: "WAITER",
    AT_DELIVERY: "AT_DELIVERY",
    AT_PICKUP: "AT_PICKUP"
}

export const CARDS = {
    CURRENT: "CURRENT",
    NEW_CARD: "NEW_CARD"
}
